import React from 'react';
import {StyledGrid} from 'presentation/components';
import emptySearch from 'presentation/assets/images/empty-search.svg';
import {Card, Stack, Typography} from '@mui/material';
import {translations} from 'presentation/translations-new';
import {EmptySearchStateProps} from './types';

const {emptySearchState} = translations['pt-br'].privateFlow.guideFlow.favoriteDoctors;

const EmptySearchState = ({isMobile}: EmptySearchStateProps) => {
	return (
		<StyledGrid.Root
			p={isMobile ? 2 : 4}
			alignContent="flex-start"
			justifyContent="center"
			height="100%">
			<StyledGrid.Item key={0} sm={12} md={12} lg={8}>
				<Card elevation={0}>
					<Stack gap={2} alignItems="center" p={3}>
						<img
							width={128}
							height={128}
							src={emptySearch}
							alt="Pessoa ajoelhada com uma lupa na mão, simbolizando a busca por um profissional"
						/>
						<Typography variant="h6">{emptySearchState.title}</Typography>
						<Typography variant="body1" textAlign="center">
							{emptySearchState.description}
						</Typography>
					</Stack>
				</Card>
			</StyledGrid.Item>
		</StyledGrid.Root>
	);
};

export {EmptySearchState};
